<template>
<div class="back-top" v-show="show" @click="backTop">
    <div class="icon"></div>
</div>
</template>

<script>
export default {
    name: 'BackTop',
    data() {
        return {
            show: false,
        };
    },
    mounted() {
        window.addEventListener('scroll', this.scrollEndFallback);
    },
    methods: {
        backTop() {
            window.scrollTo(0, 0);
        },
        scrollEndFallback() {
            let bodyTop = Math.abs(document.body.getBoundingClientRect().top);
            let distance = window.innerHeight / 2;
            if(bodyTop > distance) {
                this.show = true;
            } else {
                this.show = false;
            }
        },
    }
};
</script>

<style scoped>

.back-top {
    z-index: 999;
    position: fixed;
    right: 0.2rem;
    bottom: 0.5rem;
    width: 0.8rem;
    height: 0.8rem;
}
.icon {
    width: 0.8rem;
    height: 0.8rem;
    background-image: url(../../assets/backTop.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size:cover ;
}

.icon:hover {
    cursor: pointer;
    transform: scale(1.5);
    background-image: url(../../assets/backTopFocus.png);
}
</style>


// WEBPACK FOOTER //
// src/components/modules/BackTop.vue